import { useState } from "react";
import { Spinner } from "@/components/Spinner";
import { TitleCard } from "@/components/TitleCard";
import { useResource } from "@/hooks/useResource";
import type { TitleCard as TitleCardModel } from "@/api/types";

interface Genre {
  slug: string;
  name: string;
}

const SORTS = [
  { value: "popular", label: "Popular" },
  { value: "new", label: "New" },
  { value: "az", label: "A-Z" },
  { value: "year", label: "By year" },
];

export function Browse() {
  const [genre, setGenre] = useState("");
  const [kind, setKind] = useState("");
  const [sort, setSort] = useState("popular");
  const genres = useResource<Genre[]>("/api/v1/catalog/genres");

  const query = new URLSearchParams({ sort, page_size: "48" });
  if (genre) query.set("genre", genre);
  if (kind) query.set("kind", kind);
  const titles = useResource<{ count: number; results: TitleCardModel[] }>(
    `/api/v1/catalog/titles?${query.toString()}`,
  );

  return (
    <main className="page container">
      <div style={{ paddingTop: 34 }}>
        <h1>Browse</h1>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: "18px 0" }}>
          <button
            type="button"
            className={genre === "" ? "btn btn--accent" : "btn btn--ghost"}
            onClick={() => setGenre("")}
          >
            All genres
          </button>
          {(genres.data ?? []).map((item) => (
            <button
              key={item.slug}
              type="button"
              className={genre === item.slug ? "btn btn--accent" : "btn btn--ghost"}
              onClick={() => setGenre(item.slug)}
            >
              {item.name}
            </button>
          ))}
        </div>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {["", "movie", "series"].map((value) => (
            <button
              key={value || "all"}
              type="button"
              className={kind === value ? "btn btn--accent" : "btn btn--quiet"}
              onClick={() => setKind(value)}
            >
              {value === "" ? "Everything" : value === "movie" ? "Films" : "Series"}
            </button>
          ))}
          <div className="nav__spacer" />
          {SORTS.map((option) => (
            <button
              key={option.value}
              type="button"
              className={sort === option.value ? "btn btn--accent" : "btn btn--quiet"}
              onClick={() => setSort(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {titles.loading ? (
        <Spinner />
      ) : (
        <div className="grid">
          {(titles.data?.results ?? []).map((title) => (
            <TitleCard key={title.id} title={title} />
          ))}
        </div>
      )}
      {titles.data?.count === 0 && <div className="empty">Nothing here yet.</div>}
    </main>
  );
}
